export default {
  name: 'ngx-ui-scroll',
  version: '2.4.1'
};
